import { DateInput } from "components";
import moment from "moment";
import { useState } from "react";

interface FilterTransactionProps {
  dateFrom: string;
  dateEnd: string;
  onChangeDateFrom: (data: string) => void;
  onChangeDateEnd: (data: string) => void;
}

export function FilterTransaction({
  dateFrom,
  dateEnd,
  onChangeDateFrom,
  onChangeDateEnd,
}: FilterTransactionProps) {
  const [errorMessage, setErrorMessage] = useState("");
  const [localDateFrom, setLocalDateFrom] = useState(moment(dateFrom).toDate());
  const [localDateEnd, setLocalDateEnd] = useState(moment(dateEnd).toDate());

  const validateDates = (from: moment.Moment, end: moment.Moment): string => {
    if (from.isAfter(end)) return "Start date cannot be after end date.";
    if (end.diff(from, "days") > 30) return "The date range cannot exceed 30 days.";
    return "";
  };

  const handleChangeDateFrom = (date: Date) => {
    const newFrom = moment(date);
    const newEnd = moment(date).add(30, "days");

    setLocalDateFrom(date);
    setLocalDateEnd(newEnd.toDate());

    const error = validateDates(newFrom, newEnd);
    setErrorMessage(error);
    if (!error) {
        onChangeDateFrom(newFrom.format("YYYY-MM-DD"));
        onChangeDateEnd(newEnd.format("YYYY-MM-DD"));
    }
  };

  const handleChangeDateEnd = (date: Date) => {
    const newEnd = moment(date);
    const from = moment(localDateFrom);
    setLocalDateEnd(date);

    const error = validateDates(from, newEnd);
    setErrorMessage(error);
    if (!error) onChangeDateEnd(newEnd.format("YYYY-MM-DD"));
  };

  return (
    <section className="flex gap-2">
      <div>
        <DateInput
          label="START DATE"
          placeholderText="Date From"
          onChange={handleChangeDateFrom}
          selected={localDateFrom}
        />
        {errorMessage && (
            <p className="text-red-500 text-md mt-1">{errorMessage}</p>
        )}
      </div>

      <div>
        <DateInput
          label="END DATE"
          placeholderText="Date End"
          onChange={handleChangeDateEnd}
          selected={localDateEnd}
        />
      </div>
    </section>
  );
}
